import React from 'react';
import './styles.css'

const Navbar = ( ) => (
    <nav className="nav-container" >
        <div className="nav-content">
        <div className="nav-title">Bootcamp DevSuperior</div>
        </div>
    </nav>
   
)
export default Navbar;